export default __webpack_public_path__ + "static/media/V_wdt_c_cap_0.3b7b7f67.mp3";